import Core from "@/components/core";
import { SelectItem } from "@/components/ui/select";
import { Controller, FieldValues } from "react-hook-form";

interface Option {
  value: string;
  label: string;
}

interface ControllerInputProps {
  name: string;
  placeholder: string;
  type: string;
  label: string;
  control: any;
  errors: any;
  defaultValue?: any;
  options?: Option[];
  icon?: React.ReactNode;
}

const ConntrollerInput: React.FC<ControllerInputProps> = (props) => {
  const {
    name,
    placeholder,
    type,
    label,
    control,
    errors,
    options,
    defaultValue,
    icon,
  } = props;
  const currentDate = new Date().toISOString().split("T")[0];
  return (
    <div className="lg:col-span-6 ">
      <div className="text-start">
        <Core.Label name={name}>{label}</Core.Label>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }: { field: FieldValues }) => (
            <>
              {type === "select" && options ? (
                <Core.Select
                  onValueChange={field.onChange}
                  defaultValue={defaultValue}
                  icon={icon}
                  placeholder={placeholder}
                >
                  {options?.map((item: any) => (
                    <SelectItem key={item.value} value={item.label}>
                      {item.label}
                    </SelectItem>
                  ))}
                </Core.Select>
              ) : type === "textarea" ? (
                <Core.TextArea
                  {...field}
                  icon={icon}
                  placeholder={placeholder}
                  defaultValue={defaultValue}
                  onChange={(e: any) => field.onChange(e.target.value)}
                />
              ) : type === "date" ? (
                <Core.Input
                  {...field}
                  placeholder={placeholder}
                  type={type}
                  min={currentDate}
                  icon={icon}
                  defaultValue={defaultValue}
                />
              ) : (
                <>
                  <Core.Input
                    {...field}
                    placeholder={placeholder}
                    type={type}
                    icon={icon}
                    defaultValue={defaultValue}
                  />
                  {name === "serialNumber" && (
                    <p className="text-slate-400 text-sm mt-2 lowercase italic">
                      Serial MacBook Tertera di Bawah Bottom Case
                    </p>
                  )}
                </>
              )}
            </>
          )}
        />
        {errors[name] && (
          <span className="text-red-500">{errors[name].message}</span>
        )}
      </div>
    </div>
  );
};

export default ConntrollerInput;
